import type { SiteConfig } from "../types";
import { requestWithRetry } from "./request";

const DEFAULT_TRACKING = {
  page_views: true,
  clicks: true,
  forms: true,
  scroll: true,
  web_vitals: true,
  js_errors: false,
  page_scan: true,
};

export async function fetchSiteConfig(baseUrl: string, siteId: string): Promise<SiteConfig | null> {
  try {
    const res = await requestWithRetry(`${baseUrl}/v1/pixel/config?site_id=${encodeURIComponent(siteId)}`, {
      method: "GET",
      credentials: "omit",
    });
    if (!res.ok) return null;
    const data = (await res.json()) as Partial<SiteConfig>;
    return {
      site_id: data.site_id ?? siteId,
      allowed_domains: data.allowed_domains ?? [],
      consent_mode: (data.consent_mode as SiteConfig["consent_mode"]) ?? "none",
      tracking: { ...DEFAULT_TRACKING, ...(data.tracking ?? {}) },
      custom_goals: data.custom_goals ?? [],
      ignore_paths: data.ignore_paths ?? [],
    };
  } catch {
    return null;
  }
}
